const vendors = {}

if (process.env.SENTRY_RELEASE)
    vendors.sentry = {
        dsn: process.env.SENTRY_DSN
    }

export default vendors